import studentRequest from 'utils/studentRequest'
import instituteSelector from 'modules/Auth/selectors'
import ErrorMessage from 'utils/ErrorMessage'

export const getEventByEventIDSwitch =
  ({ eventId, pageNum, current, search, sort, paid }) =>
  async (dispatch, getState) => {
    const state = getState()
    const institute_id = instituteSelector.getInstituteDetails(state).id
   
      try {
        const pageNumber = `&pageNo=${pageNum}`
        const tab =
          current !== 'ACTIVE' ? `&Reg=${current == 'REGISTER' ? 1 : 0}` : ''
        const searchData = search !== '' ? `&searchBy=${search}` : ''
        const sortKey = sort?.columnKey ? `&sort=${sort?.columnKey}` : ''
        const order = sort?.order === 'ascend' ? 'asc' : 'desc'
        const sortOrder = sort?.order ? `&orderBy=${order}` : ''
        const paidData =
          current == 'REGISTER' ? `&isPaid=${paid ? 1 : 0}` : ''
        const result = await studentRequest.get(
          `/students/events/${eventId}/instituteCampusId/${institute_id}/studentlist?pageLimit=10${pageNumber}${tab}${searchData}${sortKey}${sortOrder}${paidData}`
        )
        return result?.data?.data
      } catch (error) {
        ErrorMessage(error)
      }

  }

export const getStatusUpdate = payload => async (dispatch, getState) => {

  try {
    const result = await studentRequest.put(
      `students/event/paid/unPaid/bulkUpdate`,
      payload
    )
    return result
  } catch (error) {
    ErrorMessage(error?.message)
  }
}

export const getStatusUpdateBulk = (payload,eventID) => async (dispatch, getState) => {

  try {
    const result = await studentRequest.put(
     `/students/events/${eventID}/student/update/status`,
      payload
    )
    return result
  } catch (error) {
    ErrorMessage(error?.message)
  }
}


export const exportEventCandidate =
  (roleId, key, payload, title, currentTab) => async (dispatch, getState) => {
    

    try {
      const state = getState()
      const institute_id = instituteSelector.getInstituteDetails(state).id
      const config = key !== 'googlesheet' ? { responseType: 'blob' } : {}
      const eventName = title ? `?eventName=${title}` : ``
      const instituteName = `&instituteName=${state?.auth?.instituteDetails?.campusName}`;
      const reg = currentTab === "REGISTER" ?  '&Reg=1' : currentTab === "UNREGISTER" ?  '&Reg=0' : ''
      const displayname = currentTab === "REGISTER" ?  `&displayname=${'Registered Student'}` : currentTab === "UNREGISTER" ?  `&displayname=${'Not Registered Student'}` : `&displayname=${'Invited Student'}`

      const response = await studentRequest.put(
        `/students/event/${roleId}/instituteCampus/${institute_id}/export/${key}${eventName}${instituteName}&forPage=true${reg}${displayname}`,
        payload,
        config
      )
      return response?.data
    } catch (err) {
      console.error('API Error:', err)
      ErrorMessage('Error fetching roles, Try again.')
      throw err // Ensure error is thrown to be caught in the calling function
    }
  }